"use strict";

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_component_helpers_1 = require("../styled-component-helpers");

var TextStyles_1 = __importDefault(require("./TextStyles")); // tslint:disable-next-line:import-name


var styled_components_1 = __importDefault(require("styled-components")); // tslint:disable-next-line:variable-name


var Heading = {
  style1: styled_components_1["default"](TextStyles_1["default"].style1.withComponent("h1"))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "], ["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "])), styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 6, styled_component_helpers_1.bp.medium2, styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 8),
  style2: styled_components_1["default"](TextStyles_1["default"].style2.withComponent("h2"))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "], ["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "])), styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 6, styled_component_helpers_1.bp.medium2, styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 8),
  style3: styled_components_1["default"](TextStyles_1["default"].style3.withComponent("h3"))(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "], ["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "])), styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.bp.medium2, styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 6),
  style4: styled_components_1["default"](TextStyles_1["default"].style4.withComponent("h4"))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "], ["\n    margin: 0 ", "px ", "px 0;\n    @media screen and (min-width: ", ") {\n      margin: 0 ", "px ", "px 0;\n    }\n  "])), styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.units.buildingUnit * 4, styled_component_helpers_1.bp.medium2, styled_component_helpers_1.units.buildingUnit * 8, styled_component_helpers_1.units.buildingUnit * 6)
};
/** @component */

exports["default"] = Heading;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;